<template>
  <span class="card simpleWorkflow__action">
    <span>
      <b-form-select
        v-model="currentActionType"
        :options="availableActions"
        @change="actionSelect"
        size="sm"
      />
    </span>
    <slot />
    <a href="#" class="simpleWorkflow__actionRemove" @click.prevent="removeAction">
      <icon name="remove" />
    </a>
  </span>
</template>

<script>
export default {
  props: ['eventBus', 'actionIdx', 'actionType', 'availableActions'],
  data() {
    return {
      currentActionType: this.actionType,
    }
  },
  methods: {
    actionSelect(type) {
      this.eventBus.$emit('setAction', { type }, this.actionIdx)

      this.$nextTick(() => this.$emit('actionSelected', type, this.actionIdx))
    },
    removeAction() {
      this.eventBus.$emit('removeAction', this.actionIdx)
    },
  },
}
</script>
